import React, { memo } from 'react';
export var RecommendedIcon = /*#__PURE__*/memo(function (_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 207 53",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, '4F8B8559-5344-4C60-B16F-32919950C86A'), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003B5C",
    d: "M.375 0h206.25v45.429h-92.439L105.638 53l-8.574-7.571H.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.54 13.118l.916.596c.367.229.733.32 1.146.274l.687-.045c.733-.092 1.375.274 1.696.916l.504.961c.183.367.458.641.87.825l.596.274c.687.275 1.1.916 1.054 1.65l-.092 1.098c0 .412.092.779.367 1.145l.366.504a1.65 1.65 0 01.046 1.97l-.55.915c-.275.366-.366.733-.275 1.145l.046.687c.092.733-.275 1.374-.916 1.694l-.963.504c-.412.183-.641.458-.824.87l-.275.596c-.275.687-.917 1.099-1.696 1.053l-1.054-.092c-.412 0-.779.092-1.145.367l-.504.366c-.596.458-1.375.458-2.016.046l-.871-.55c-.367-.274-.733-.366-1.146-.274l-.687.045c-.733.092-1.375-.274-1.741-.916l-.459-.961c-.183-.412-.458-.641-.87-.825l-.596-.274c-.687-.275-1.1-.916-1.054-1.695l.092-1.053c0-.412-.092-.779-.367-1.145l-.366-.504a1.72 1.72 0 01-.092-2.015l.596-.87c.229-.366.32-.733.275-1.145l-.046-.687c-.092-.733.275-1.374.916-1.74l.963-.458c.366-.183.641-.458.824-.87l.275-.596a1.64 1.64 0 011.65-1.053l1.1.092c.412 0 .779-.092 1.145-.367l.504-.366c.596-.458 1.375-.504 1.97-.092zm-4.57 9.743c-.281-.275-.281-.733 0-1.054.327-.275.794-.275 1.074 0l1.543 1.512 3.458-3.62a.705.705 0 011.029-.046.673.673 0 01.046 1.008l-3.972 4.216a.76.76 0 01-1.075.046l-2.104-2.062z",
    fill: "#FFA06A"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins Medium",
    fontSize: 17.014,
    letterSpacing: -0.262,
    fill: "#FFF",
    transform: "translate(28 10)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, 'Recommended '))));
});